import React from 'react';
import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import { Grid, Form, Button, Divider, Icon, Checkbox, Radio } from 'semantic-ui-react';
import TableGrid from 'semantic-table-grid';
import styled from 'styled-components';
import moment from 'moment';
import _ from 'lodash';
// import uuidV4 from 'uuid/v4';

import { Center, Column } from 'components/Layout';
import { DOCUMENTS, ACL } from 'shared/constants';
import aclService from 'shared/lib/acl';
import AnagraficaService from 'shared/services/api/anagrafica';
import ContrattoService from 'shared/services/api/collaboratore/contratto';
import ProfiloService from 'shared/services/api/collaboratore/profilo';
import TutorService from 'shared/services/api/tutor';

import { Input } from '../../UI/Input';
// import { SingleSelect } from '../../UI/Select';
import { DatePicker } from '../../UI/DatePicker';
import { SuggestComuneString, SuggestIndirizzo } from '../../UI/GeoSuggest';
import DividerForm from '../../UI/DividerForm';
import { Upload } from '../../UI/Upload';
import AddableModal from '../../UI/AddableModal';
import EmptyMessage from '../../UI/EmptyMessage';

import ContrattoForm from './contrattoForm';
import { mapToCollaboratoreInitialValues } from './initialValues';
import ProfiloForm from './profiloForm';
import TuteeForm from './tuteeForm';

const RadioLabel = styled.span`
  font-weight: bold;
  margin-left: 10px;
  position: absolute;
  margin-top: 3px;
`;

const attivoFormatter = (props) => (
  <Center>
    {_.get(props, 'data.attivo') ? (
      <Icon name="checkmark" color="green" size="large" />
    ) : (
      <Icon name="delete" color="red" size="large" />
    )}
  </Center>
);

export class CollaboratoreForm extends React.Component {
  state = {
    loadingPiva: false,
    tutees: [],
    hideExpiredTutee: true,
    isTuteeLoading: false,
    tutor: [],
    isTutorLoading: true,
  };

  componentDidMount() {
    this.getTutee();
    this.getTutor();
  }

  getPIVA = (props) => {
    this.setState({ loadingPiva: true }, () =>
      AnagraficaService.getPIVA(props.values.anagrafica).then((res) => {
        props.setFieldValue('partitaiva', res);
        this.setState({ loadingPiva: false });
      })
    );
  };

  getTutee = () => {
    this.setState({ isTuteeLoading: true });
    TutorService.getAll(this.props.values.id, this.state.hideExpiredTutee).then((res) =>
      this.setState({ tutees: _.get(res, '_embedded.tutor_tutee') || [] }, () =>
        this.setState({ isTuteeLoading: false })
      )
    );
  };

  getTutor = () => {
    this.setState({ isTutorLoading: true });
    TutorService.getByTutee(this.props.values.id, true)
      .then((res) => {
        const now = moment();

        if (res && res._embedded && !_.isEmpty(res._embedded.tutor_tutee)) {
          const rapportoAttivo = res._embedded.tutor_tutee.find((r) => {
            const inizio = moment.unix(r.dataInizioValidita);
            const fine = r.dataFineValidita ? moment.unix(r.dataFineValidita) : null;

            return inizio.isSameOrBefore(now) && (fine === null || fine.isAfter(now));
          });

          const profiloTutorAttivo = !_.isEmpty(rapportoAttivo) ? rapportoAttivo : null;
          if (!_.isEmpty(profiloTutorAttivo)) {
            this.setState({ tutor: [profiloTutorAttivo] });
          }
        }
      })
      .finally(() => this.setState({ isTutorLoading: false }));
  };

  switchGetExpiredTutee = (e, data) => {
    this.setState({ hideExpiredTutee: data.checked }, this.getTutee);
  };

  profiliColumns = [
    {
      key: 'tipoProfiloCollaboratore',
      name: 'Tipo',
      formatter: ({ data }) => (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 11, color: 'rgb(51, 61, 104)' }}>
            Dal {data.dataInizioValidita ? data.dataInizioValidita.format('DD/MM/YYYY') : '--'}
          </div>
          <div style={{ fontSize: 11, color: 'rgb(51, 61, 104)' }}>
            Al {data.dataFineValidita ? data.dataFineValidita.format('DD/MM/YYYY') : '--'}
          </div>
          <div>{data.tipoProfiloCollaboratore ? data.tipoProfiloCollaboratore.label : ''}</div>
        </div>
      ),
      sortable: false,
    },
    {
      key: 'agenziakiron',
      name: 'Agenzia',
      formatter: ({ data }) => (data.agenziakiron ? data.agenziakiron.label : ''),
      sortable: false,
    },
    {
      key: 'gruppo',
      name: 'Gruppo',
      formatter: ({ data }) => (data.gruppo ? data.gruppo.label : ''),
      sortable: false,
    },
    { key: 'attivo', name: 'Attivo', formatter: attivoFormatter },
  ];

  contrattiColumns = [
    { key: 'tipologia', name: 'Tipologia', sortable: false },
    {
      key: 'dataDecorrenza',
      name: 'Decorrenza',
      formatter: ({ data }) => (data.dataDecorrenza ? data.dataDecorrenza.format('DD/MM/YYYY') : '--'),
      sortable: false,
    },
    {
      key: 'dataRescissione',
      name: 'Rescissione',
      formatter: ({ data }) => (data.dataRescissione ? data.dataRescissione.format('DD/MM/YYYY') : '--'),
      sortable: false,
    },
    { key: 'attivo', name: 'Attivo', formatter: attivoFormatter },
  ];

  tuteeColumns = [
    {
      key: 'nominativo',
      name: 'Nominativo',
      formatter: ({ data }) => _.get(data, 'profiloTutee.nominativo') || '--',
      sortable: false,
    },
    {
      key: 'tipo',
      name: 'Profilo',
      formatter: ({ data }) => _.get(data, 'profiloTutee.tipo') || '--',
      sortable: false,
    },
    {
      key: 'percentualeOver',
      name: 'Percentuale',
      formatter: ({ data }) => `${_.get(data, 'percentualeOver')}%` || '--',
      sortable: false,
    },
    {
      key: 'dataInizioValidita',
      name: 'Inizio validità',
      formatter: ({ data }) =>
        data.dataInizioValidita ? moment.unix(data.dataInizioValidita).format('DD/MM/YYYY') : '--',
      sortable: false,
    },
    {
      key: 'dataFineValidita',
      name: 'Fine validità',
      formatter: ({ data }) => (data.dataFineValidita ? moment.unix(data.dataFineValidita).format('DD/MM/YYYY') : '--'),
      sortable: false,
    },
  ];

  tutorColumns = [
    {
      key: 'nominativo',
      name: 'Nominativo',
      formatter: ({ data }) => _.get(data, 'profiloTutor.nominativo') || '--',
      sortable: false,
    },
    {
      key: 'dataInizioValidita',
      name: 'Inizio validità',
      formatter: ({ data }) =>
        data.dataInizioValidita ? moment.unix(data.dataInizioValidita).format('DD/MM/YYYY') : '--',
      sortable: false,
    },
    {
      key: 'dataFineValidita',
      name: 'Fine validità',
      formatter: ({ data }) => (data.dataFineValidita ? moment.unix(data.dataFineValidita).format('DD/MM/YYYY') : '--'),
      sortable: false,
    },
  ];

  addTutee = (tutee) => {
    const tutorato = Object.assign({}, tutee);
    tutorato.dataFineValidita = tutorato.dataFineValidita ? +tutorato.dataFineValidita.format('X') : '';
    tutorato.dataInizioValidita = tutorato.dataInizioValidita ? +tutorato.dataInizioValidita.format('X') : '';
    tutorato.tutee = _.get(tutorato, 'tutee.value') || _.get(tutorato, 'tutee');
    // console.log("TUTEE", tutorato);
    if (tutorato.id) {
      // If already in DB
      return TutorService.put(tutorato)
        .then((data) => {
          this.props.notifications.addNotification({
            message: 'Tutoring modificato con successo',
            level: 'success',
          });
          this.getTutee();
          return data;
        })
        .catch((err) => {
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella modifica del tutoring',
            level: 'error',
          });
          return err;
        });
    } else {
      // eslint-disable-line
      return TutorService.create(tutorato)
        .then((data) => {
          this.props.notifications.addNotification({
            message: 'Tutoring creato con successo',
            level: 'success',
          });
          this.getTutee();
          return data;
        })
        .catch((err) => {
          // console.log("ERRORE PROFILO", err);
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella creazione del tutoring',
            level: 'error',
          });
          return err;
        });
    }
  };

  addProfilo = (profile) => {
    /* const profili = this.props.values.profili.slice();
    const profile = Object.assign({}, profilo);
    if (profile.id) { // If already in DB
      profili[_.findIndex(profili, (o) => o.id === profile.id)] = profile;
    } else if (!profile.uuid) { // If just added
      profile.uuid = uuidV4();
      profili.unshift(profile);
    } else if (profile.uuid) {
      profili[_.findIndex(profili, (o) => o.uuid === profile.uuid)] = profile; // Edit a profile not yet in db
    }

    this.props.setFieldValue('profili', profili);*/
    const profilo = Object.assign({}, profile);

    profilo.dataFineValidita = profilo.dataFineValidita ? +profilo.dataFineValidita.format('X') : '';
    profilo.dataInizioValidita = profilo.dataInizioValidita ? +profilo.dataInizioValidita.format('X') : '';
    profilo.agenziakiron = profilo.agenziakiron ? profilo.agenziakiron.value : '';
    profilo.gruppo = profilo.gruppo ? profilo.gruppo.value : '';
    profilo.tipoProfiloCollaboratore = profilo.tipoProfiloCollaboratore ? profilo.tipoProfiloCollaboratore.value : '';

    delete profilo.createdAt;
    delete profilo.gruppi;
    delete profilo.uuid;

    profilo.collaboratore = this.props.values.id;
    // console.log("PROFILO", profilo);
    if (profilo.id) {
      // If already in DB
      return ProfiloService.put(profilo)
        .then((data) => {
          this.props.notifications.addNotification({
            message: 'Profilo modificato con successo',
            level: 'success',
          });
          this.refreshProfili();
          return data;
        })
        .catch((err) => {
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella modifica del profilo',
            level: 'error',
          });
          return err;
        });
    } else {
      // eslint-disable-line
      return ProfiloService.create(profilo)
        .then((data) => {
          this.props.notifications.addNotification({
            message: 'Profilo creato con successo',
            level: 'success',
          });
          this.refreshProfili();
          return data;
        })
        .catch((err) => {
          // console.log("ERRORE PROFILO", err);
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella creazione del profilo',
            level: 'error',
          });
          return err;
        });
    }
  };

  refreshContratti = () => {
    this.props.setSubmitting(true);
    ContrattoService.getContrattiByCollaboratore(this.props.values.id).then((res) => {
      const fakeCollaboratore = {}; // Simulo un collaboratore per utilizzare il mapInitialValues
      fakeCollaboratore.contratti = res._embedded.contrattocollaboratore;
      const mappedCollaboratore = mapToCollaboratoreInitialValues(fakeCollaboratore);
      this.props.setFieldValue('contratti', mappedCollaboratore.contratti);
      this.props.setSubmitting(false);
    });
  };

  refreshProfili = () => {
    this.props.setSubmitting(true);
    ProfiloService.getProfiliByCollaboratore(this.props.values.id).then((res) => {
      const fakeCollaboratore = {}; // Simulo un collaboratore per utilizzare il mapInitialValues
      fakeCollaboratore.profili = res._embedded.profilocollaboratore;
      const mappedCollaboratore = mapToCollaboratoreInitialValues(fakeCollaboratore);
      this.props.setFieldValue('profili', mappedCollaboratore.profili);
      this.props.setSubmitting(false);
      this.getTutee();
    });
  };

  addContratto = (contratto) => {
    // const contratti = this.props.values.contratti.slice();
    const contract = Object.assign({}, contratto);
    contract.dataDecorrenza = contratto.dataDecorrenza ? +contratto.dataDecorrenza.format('X') : '';
    contract.dataRescissione = contratto.dataRescissione ? +contratto.dataRescissione.format('X') : '';
    contract.collaboratore = this.props.values.id;
    delete contract.attivo;
    if (contratto.id) {
      // If already in DB
      // contratti[_.findIndex(contratti, (o) => o.id === contract.id)] = contract;
      return ContrattoService.put(contract)
        .then((data) => {
          this.props.notifications.addNotification({
            message: 'Contratto modificato con successo',
            level: 'success',
          });
          this.refreshContratti();
          return data;
        })
        .catch((err) => {
          // console.log("ERRORE NELLA CREAZIONE DEL CONTRATTO", err)
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella modifica del contratto',
            level: 'error',
          });
          return err;
        });
    } else {
      // eslint-disable-line
      return ContrattoService.create(contract)
        .then((data) => {
          // console.log("CONTRATTO CREATO", res)
          this.props.notifications.addNotification({ message: 'Contratto creato con successo', level: 'success' });
          this.refreshContratti();
          return data;
        })
        .catch((err) => {
          // console.log("ERRORE NELLA CREAZIONE DEL CONTRATTO", err)
          this.props.notifications.addNotification({
            message: _.get(err, 'data.detail') || 'Errore nella creazione del contratto',
            level: 'error',
          });
          return err;
        });
    }

    /* if (!contract.uuid) { // If just added
      contract.uuid = uuidV4();
      contratti.unshift(contract);
    } else if (contract.uuid) {
      contratti[_.findIndex(contratti, (o) => o.uuid === contract.uuid)] = contract; // Edit a contract not yet in db
    }*/
    // this.props.setFieldValue('contratti', contratti);
  };

  /* getActiveProfiles = (profiliArray) => {
    const profili = _.cloneDeep(profiliArray);
    const activeProfiles = profili.filter(
      (profilo) => !profilo.dataFineValidita || (profilo.dataFineValidita.format('X') > moment(new Date()).format('X'))
    );
    console.log(activeProfiles);
    return activeProfiles;
  }*/
  deleteTutee = (tutee) =>
    TutorService.del(tutee.id)
      .then(() => {
        // console.log("CANCELLATO", res);
        this.getTutee();
      })
      .catch((err) => {
        this.props.notifications.addNotification({
          message: _.get(err, 'data.detail') || 'Errore nella cancellazione di un tutoring',
          level: 'error',
        });
        return err;
      });

  render() {
    return (
      <Form autoComplete="off" onSubmit={this.props.handleSubmit} loading={this.props.isSubmitting}>
        <Column width={16} key="tipologia-anagrafica">
          <Divider horizontal>Dati professionali</Divider>
        </Column>
        <Grid>
          <Column width={8}>
            <Input label="Ragione Sociale" {...this.props} name="ragioneSociale" />
          </Column>
          <Column width={8}>
            <Input
              label="Partita IVA"
              style={{ position: 'relative' }}
              {...this.props}
              name="partitaiva"
              btn={{
                loading: this.state.loadingPiva,
                action: () => this.getPIVA(this.props),
                icon: 'copy',
                tooltip: 'Copia da anagrafica',
              }}
            />
          </Column>
          <Column width={16}>
            <SuggestIndirizzo
              initialValue={this.props.values.indirizzoCompleto}
              onChange={this.props.setFieldValue}
              onBlur={this.props.setFieldTouched}
              error={this.props.errors.indirizzoCompleto}
              touched={this.props.touched.indirizzoCompleto}
              elements={[
                {
                  comune: this.props.values.comune || '',
                  provincia: this.props.values.provincia || '',
                  regione: this.props.values.regione || '',
                  cap: this.props.values.cap || '',
                  indirizzo: this.props.values.indirizzo || '',
                  nazione: this.props.values.nazione || '',
                  numeroCivico: this.props.values.numeroCivico || this.props.values.numero || '',
                  tipo: 'sedelegale',
                },
              ]}
              flat
              label="Sede legale"
              name="sedelegale"
            />
          </Column>
          <Column width={16} key="tipologia-anagrafica">
            <Divider horizontal>Dati Enasarco</Divider>
          </Column>
          <Column width={6}>
            <Input label="N° Iscrizione" {...this.props} name="enasarcoNumeroIscrizione" />
          </Column>
          <Column width={5}>
            <DatePicker
              {...this.props}
              value={this.props.values.enasarcoDataIscrizione}
              onChange={this.props.setFieldValue}
              name="enasarcoDataIscrizione"
              label="Data iscrizione"
              startDate={moment()}
              openDirection="up"
            />
          </Column>
          <Column width={5}>
            <DatePicker
              {...this.props}
              value={this.props.values.enasarcoDataCessazione}
              onChange={this.props.setFieldValue}
              name="enasarcoDataCessazione"
              label="Data cessazione"
              startDate={moment()}
              openDirection="up"
            />
          </Column>

          <Column width={8}>
            <Input label="N° carta versamento" {...this.props} name="numeroCartaVersamento" />
          </Column>
          <Column width={8}>
            <Input label="Rete di provenienza" {...this.props} name="reteProvenienza" />
          </Column>
          <Column width={16}>
            <Divider horizontal>Dati REA</Divider>
          </Column>
          <Column width={6}>
            <SuggestComuneString
              initialValue={this.props.values.registroImprese}
              onChange={this.props.setFieldValue}
              onBlur={this.props.setFieldTouched}
              error={this.props.errors.registroImprese}
              touched={this.props.touched.registroImprese}
              name="registroImprese"
              label="Registro imprese"
            />
          </Column>
          <Column width={5}>
            <Input label="REA" {...this.props} name="rea" />
          </Column>
          <Column width={5}>
            <Input label="Codice attività" {...this.props} name="codiceAttivita" />
          </Column>
          <Column width={16}>
            <AddableModal
              columns={this.contrattiColumns}
              elements={this.props.values.contratti || []}
              emptyMessage="Nessun contratto inserito"
              addModalTitle="Nuovo contratto"
              sectionTitle="Contratti stipulati"
              modalSize="tiny"
              onChange={this.props.setFieldValue}
              validateBeforeAdd={(this.props.values.contratti || []).every((el) => el.dataRescissione)}
              validateBeforeAddMessage="Prima di inserire un nuovo contratto bisogna assegnare la data di rescissione al contratto precedente"
              validateBeforeAddEnabled
              hideDelete
            >
              <ContrattoForm addAction={this.addContratto} />
            </AddableModal>
          </Column>
          <Column width={16}>
            <AddableModal
              columns={this.profiliColumns}
              elements={this.props.values.profili || []}
              emptyMessage="Nessun profilo assegnato"
              addModalTitle="Aggiungi profilo"
              sectionTitle="Profili associati"
              modalSize="mini"
              onChange={this.props.setFieldValue}
              hideDelete
            >
              <ProfiloForm addAction={this.addProfilo} />
            </AddableModal>
          </Column>
          <Column width={16}>
            <Checkbox
              label="Abilitazione profilo tutor"
              onChange={async (el, val) => {
                await this.props.setFieldValue('tutor', val.checked);
                this.props.handleSubmit({ preventDefault: () => true });
              }}
              checked={this.props.values.tutor}
              style={{ marginTop: 15, marginBottom: 15 }}
            />
            <AddableModal
              isLoading={this.state.isTuteeLoading}
              columns={this.tuteeColumns}
              elements={this.state.tutees || []}
              emptyMessage="Nessun tutee assegnato"
              addModalTitle="Aggiungi tutee"
              sectionTitle="Tutee associati"
              modalSize="mini"
              onChange={() => {}}
              onDelete={this.deleteTutee}
              hideAdd={!this.props.values.tutor}
              canAction={{
                active: true,
                actions: [
                  <Radio
                    toggle
                    checked={this.state.hideExpiredTutee}
                    label="Nascondi tutee scaduti"
                    onChange={this.switchGetExpiredTutee}
                  />,
                ],
              }}
              conditionalHideEditOnRow={(data) =>
                !data.dataFineValidita || !moment().isAfter(moment.unix(data.dataFineValidita), 'day')
              }
            >
              <TuteeForm collaboratoreId={this.props.values.id} addAction={this.addTutee} />
            </AddableModal>
          </Column>
          <Column width={16}>
            <Divider horizontal>Tutor associato</Divider>
            <TableGrid
              key="tablegrid-tutor"
              columns={this.tutorColumns}
              canSelect={false}
              elements={this.state.tutor || []}
              hiddenHeaderIfEmpty
              isLoading={this.state.isTutorLoading || false}
              emptyResults={<EmptyMessage>Nessun tutor attivo</EmptyMessage>}
            />
          </Column>

          {aclService.check(this.props.auth, ACL.CAN_VIEW_PIGNORAMENTO) && (
            <Column width={16}>
              <Divider horizontal>Pignoramento</Divider>
              <Radio
                toggle
                checked={this.props.values.pignoramento}
                onChange={(el, val) => this.props.setFieldValue('pignoramento', val.checked)}
              />
              <RadioLabel>Pignoramento</RadioLabel>
              {!!this.props.values.pignoramento && (
                <Input
                  style={{ marginTop: '15px' }}
                  label="Note pignoramento"
                  {...this.props}
                  name="notePignoramento"
                />
              )}
            </Column>
          )}
          {aclService.check(this.props.auth, ACL.CAN_VIEW_COLLABORATORE_ACCESS_LOCK) && (
            <Column width={16}>
              <Divider horizontal>Gestione permessi Campus</Divider>
              <Radio
                toggle
                checked={this.props.values.campusAccessBlocked}
                onChange={(el, val) => this.props.setFieldValue('campusAccessBlocked', val.checked)}
              />
              <RadioLabel>
                {this.props.values.campusAccessBlocked ? 'Accesso campus bloccato' : 'Accesso campus sbloccato'}
              </RadioLabel>
              <br />
              <br />
              <Radio
                toggle
                checked={this.props.values.accessoSharedMail}
                onChange={(el, val) => this.props.setFieldValue('accessoSharedMail', val.checked)}
              />
              <RadioLabel>{'Accesso shared mail'}</RadioLabel>
            </Column>
          )}
          <Column width={16}>
            <Divider horizontal>Stampa contratto</Divider>
          </Column>
          <Column width={16} style={{ marginBottom: 22 }}>
            <Upload
              endpoint={DOCUMENTS.CONTRATTO_COLLABORATORE}
              collaboratoreId={this.props.values.id}
              downloadId={this.props.values.allegatoContratto || false}
              title="Contratto collaboratore"
              description="Contratto del collaboratore per visualizzazione e stampa"
              errors={this.props.errors}
              setAllegato={(id) => this.props.setFieldValue('allegatoContratto', id)}
              showVersions
            />
          </Column>
          <DividerForm />
          <Column width={8}>
            <Button
              onClick={this.props.closeModal}
              type="button"
              icon="delete"
              labelPosition="right"
              content="Chiudi"
            />
          </Column>
          <Column width={8} textAlign="right">
            <Button
              loading={this.props.isSubmitting}
              type="submit"
              icon="save"
              labelPosition="left"
              positive
              disabled={this.props.isSubmitting}
              content="Salva"
            />
          </Column>
        </Grid>
      </Form>
    );
  }
}

export default CollaboratoreForm;

CollaboratoreForm.propTypes = {
  isSubmitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldTouched: PropTypes.func,
  handleSubmit: PropTypes.func,
  closeModal: PropTypes.func,
  notifications: PropTypes.object,
  auth: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/Form.js